import { useContext } from 'react';
import { useQueryClient, useMutation } from 'react-query';
import { FetchContext } from 'context/FetchContext';

function useReorderPlayable() {
  const { privateFetch } = useContext(FetchContext);
  const queryClient = useQueryClient();

  function reorderPlayable({ podcastId, episodeId, data }) {
    if (!podcastId || !episodeId) {
      throw new Error('podcastId and episodeId are required');
    }

    return privateFetch.put(
      `/v1/admin/podcast/${podcastId}/episode/${episodeId}/playables/reorder`,
      data
    );
  }

  return useMutation(reorderPlayable, {
    onSuccess() {},
    onError(error) {
      console.error('Failed to reorder playables:', error);
    },
  });
}

export default useReorderPlayable;
